const state = {
  surveys: []
};
const getters = {
  getSurveys: state => {
    var surveys = state.surveys;
    if (surveys.length == 0) return null;
    else return state.surveys;
  }
};
const mutations = {
  updateSurveys: (state, payload) => {
    state.surveys = payload;
    console.log(payload);
  }
};
const actions = {
  fetchSurveys({ commit }) {
    // var surveys = [];
    // var surveysRef = db.collection("surveys");

    // if (surveysRef !== null) {
    //   surveysRef.onSnapshot(querySnapshot => {
    //     surveys = [];
    //     querySnapshot.forEach(doc => {
    //       surveys.push(doc.data());
    //     });
    //     commit("updateSurveys", surveys);
    //   });
    // }
  }
};

export default { state, getters, mutations, actions };
